<template>
  <div>
    <LandingPageModal
      v-if="showModal"
      @close="showModal = false"
      style="font-size: 20px"
    >
      <template v-slot:header>
        <h1 class="mx-auto" style="font-size: 30px;">We are upgrading!</h1>
      </template>
      <template v-slot:body>
        <div>
          <h3>Hi PYB Shopper,</h3>
          <br />
          <p>
            Great News. We are updating our Miami shipping address to serve you
            better.
          </p>

          <p>
            During this period, you can sign up, but shipping barrels will
            resume on July 29, 2024.
          </p>

          <p>Thank you for your understanding.</p>
          <h4>-Team PYB</h4>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary mx-auto" @click="showModal = false">
          OK
        </button>
      </template>
    </LandingPageModal>
  </div>
</template>

<script>
import LandingPageModal from "@/components/LandingPageModal.vue";

export default {
  name: "DisableWarehouse",
  components: {
    LandingPageModal,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showPopup() {},
  },
};
</script>

<style lang="scss" scoped>
</style>